<template>
  <worker title="非在职员工信息管理" isDiscipline="yes"></worker>
</template>

<script>
import Worker from './worker'

export default {
  components: { Worker }
}
</script>
